
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gtbWXIBKhhfzavgGl_Q2xDkvqxWfldIudy2DIPCM9l5IMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexPdyERIMH_U5VdrWpsDwxpOA_45si1JD4VIZ3MGSIifiU4Meta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchEJtUMn6Cycj7K_Za7k01evv_XSdlevxZexMoqhQs67oMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexRMcfJzGto_45rit3s3QTdfX_J8vTCHhMogulLk7ceh4eAMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93c5_SGVaefcj0X8liQRrZ_45KuUHHtuu9Yn_5MkVz6hFu4Meta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexIBAMSRfj04iPyo4wW1Au_453OGgRXfBFwqU_CtrJAUi24Meta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Ed0tnwxVUPWgBuaq51B3RGey9Z4oiimoLHM6PfNygdsMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexhiD2Tl8yEgnBmFFW2H3doOwPnVsN2B2HsolrHBAStoUMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93RTpJYWRtWZ1SGIl83K0FrvRmSG8qWPviHF_45mODGUDUAMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexTXvhrn32BtHFeWi_JnwhAxrTccWGQnli6gL_swlaZvIMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexqb_45iLtVX867sIqygINPUwdPDmwdYnCgPyBPkXqPXm_45oMeta } from "/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexIBAMSRfj04iPyo4wW1Au_453OGgRXfBFwqU_CtrJAUi24Meta || {},
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexhiD2Tl8yEgnBmFFW2H3doOwPnVsN2B2HsolrHBAStoUMeta || {},
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexTXvhrn32BtHFeWi_JnwhAxrTccWGQnli6gL_swlaZvIMeta || {},
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexqb_45iLtVX867sIqygINPUwdPDmwdYnCgPyBPkXqPXm_45oMeta || {},
    component: () => import("/codebuild/output/src2810133552/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]